module.exports = __webpack_public_path__ + "img/04_uk.152ccc72.svg";